import React, { Fragment, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AltLogo from "../../assets/images/altracialogo.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import ListIcon from "@mui/icons-material/List";
import { Apartment } from "@mui/icons-material";

import TableViewIcon from "@mui/icons-material/TableView";

import ViewInArIcon from "@mui/icons-material/ViewInAr";

import NotificationsIcon from "@mui/icons-material/Notifications";

import RuleIcon from "@mui/icons-material/Rule";

import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import LockIcon from "@mui/icons-material/Lock";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import CodeIcon from "@mui/icons-material/Code";

import SourceIcon from "@mui/icons-material/Source";
import ErrorIcon from "@mui/icons-material/Error";
import KeyIcon from "@mui/icons-material/Key";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import SmsIcon from "@mui/icons-material/Sms";
import MapIcon from "@mui/icons-material/Map";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PublicIcon from "@mui/icons-material/Public";
import CircleIcon from "@mui/icons-material/Circle";
import PreviewIcon from "@mui/icons-material/Preview";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import LanguageIcon from "@mui/icons-material/Language";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CreateIcon from "@mui/icons-material/Create";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import AddIcon from "@mui/icons-material/Add";
import LoginIcon from "@mui/icons-material/Login";

import FilterListIcon from "@mui/icons-material/FilterList";

import BlockIcon from "@mui/icons-material/Block";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import SendIcon from "@mui/icons-material/Send";
import Navbar from "./Navbar";
import { common_axios } from "../../App";
// import "./Sidebar.css";
import { useEffect } from "react";
import { Icon } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { useDispatch } from "react-redux";
import { setSectionClass } from "../../redux/features/sidebarSlice";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export default function Sidebarupdated() {
  let Sidebars;

  const [userDetails, setUserDetails] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const [MenuClass, setMenuClass] = useState(
    JSON.parse(localStorage.getItem("menuclasses"))
      ? JSON.parse(localStorage.getItem("menuclasses"))
      : []
  );
  const [MenuClass1, setMenuClass1] = useState(
    JSON.parse(localStorage.getItem("menuclasses"))
      ? JSON.parse(localStorage.getItem("menuclasses"))
      : []
  );
  // console.log(
  //   "KKKKKKKKKK",
  //   JSON.parse(localStorage.getItem("menuclasses")),
  //   MenuClass
  // );
  const [activeIndex, setactiveIndex] = useState(null);
  const [indexcolor, setindexcolor] = useState("");
  const [navopen, setnavopen] = useState(false);
  const [indexxx, setindexxx] = useState([]);

  if (
    localStorage.getItem("Sidebaritems") != undefined ||
    localStorage.getItem("Sidebaritems") != null
  ) {
    Sidebars = JSON.parse(localStorage.getItem("Sidebaritems"));
  }

  let ar = [
    {
      id: 0,
      isActive: true,
      menu: "Dashboard",
      menuClass: null,
      menuIcon: "dashboard_icon",

      //   menu: "Dashboard",
      //   groupId: "",
      //   id: 0,
      //   isActive: true,
      //   menuClass: "dashboard_icon",
      subMenu: [],
    },
  ];

  Sidebars?.mainMenu.unshift(ar[0]);

  //   const Sidebar = [ar[0], ...Sidebars?.mainMenu];

  const Sidebar = Sidebars?.mainMenu;
  // console.log("d8", Sidebar);

  const sidebarr = Sidebar?.sort((a, b) => (a?.id > b?.id ? 1 : -1));

  const [MenuSearch, setMenuSearch] = useState(sidebarr);
  const [Menu, setMenu] = useState(Sidebars?.mainMenu);
  const [search, setsearch] = useState([]);

  const performSearch = async () => {
    const results = Sidebars?.mainMenu?.filter((item) =>
      item?.menu?.toLowerCase().includes(search?.toLowerCase())
    );
    setMenuSearch(results);
  };

  // console.log("d89", MenuSearch);

  // useEffect(() => {
  //   performSearch();
  // }, [search]);

  // useEffect(() => {
  //   let arrow = document.querySelectorAll(".arrow");
  //   let iocnLink = document.querySelectorAll(".iocn-link");

  //   for (var i = 0; i < arrow.length; i++) {
  //     arrow[i].addEventListener("click", (e) => {
  //       let arrowParent = e.target.parentElement.parentElement;

  //       //selecting main parent of arrow
  //       arrowParent.classList.toggle("showMenu");
  //     });
  //     iocnLink[i]?.addEventListener("click", (e) => {
  //       let arrowParentDown =
  //         e.target.parentElement.parentElement.parentElement;

  //       //selecting main parent of arrow
  //       arrowParentDown.classList.toggle("showMenu");
  //     });
  //   }

  //   let sidebar = document.querySelector(".sidebar");

  //   let sidebarBtn = document.getElementById("iconNavbarSidenav");

  //   sidebarBtn.addEventListener("click", () => {
  //     sidebar.classList.toggle("close");
  //   });
  // }, []);
  // console.log("9j", sidebarr, MenuClass);

  const history = useHistory();
  let screensize = window?.innerWidth;

  useEffect(async () => {
    // alert("dhi");
    // if (sidebarr?.length > 0) {
    //   let arr = [];
    //   for (let index = 0; index < sidebarr?.length; index++) {
    //     let obj = {};
    //     // if (activeIndex != index) obj[`class${index}`] = "my-2";
    //     if (localStorage.getItem("sideindex") != index)
    //       obj[`class${index}`] = "my-2";
    //     else obj[`class${index}`] = "my-2 activelinks activeLink";
    //     const element = sidebarr?.[index];
    //     // arr.push(obj);
    //   }
    //   console.log({ arr });
    //   setMenuClass(arr);
    //   setMenuClass1(arr);
    // }
    if (MenuClass?.length == 0) {
      let obj = {};
      for (let index = 0; index < sidebarr?.length; index++) {
        obj[`class${sidebarr[index].menu.replaceAll(" ", "")}`] = "my-2";
        // const element = res.data.mainMenuList?.[index];
        // arr.push(obj);
      }

      await setMenuClass(obj);
      await setMenuClass1(obj);
    }
  }, []);

  // useEffect(async () => {
  //   await setTimeout(() => {
  //     if (sidebarr.length > 0) {
  //       setMenuClass(JSON.parse(localStorage.getItem("menuclasses")));
  //     } else {
  //     }
  //   }, 1500);
  // }, [JSON.parse(localStorage.getItem("menuclasses"))]);

  useEffect(() => {
    if (!navopen) dispatch(setSectionClass(true));
    if (navopen) dispatch(setSectionClass(false));
  }, [navopen]);

  if (
    document?.getElementById("main-section-sidebar")?.classList != undefined
  ) {
    if (navopen == false) {
      document.body.className = "g-sidenav-show bg-gray-200 ";
      // const section = document?.getElementById("main-section-sidebar");
      // section.classList.value = "sec_1";
    } else {
      document.body.className = "g-sidenav-show bg-gray-200 g-sidenav-pinned";
      // const section = document?.getElementById("main-section-sidebar");
      // section.classList.value = "sec_2";
    }
  }
  const location = useLocation();
  return (
    <>
      <ToastContainer autoClose={4000} />
      <div className="d-none"></div>

      {/* <aside
        className="sidenav navbar navbar-vertical navbar-expand-xs border-0 fixed-start bg-gradient-dark"
        id="sidenav-main"
      >
        <div className="sidenav-header">
          <i
            className="fas fa-times p-3 cursor-pointer text-white opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
            aria-hidden="true"
            id="iconSidenav"
          ></i>

          <Link className="navbar-brand m-0" to="/dashboard">
            <img
              src={AltLogo}
              className="navbar-brand-img h-100"
              alt="main_logo"
            />
            <span className="ms-1 font-weight-bold text-white">Altruist</span>
          </Link>
        </div>
        <hr className="horizontal light mt-0 mb-2" />
        <div
          className="collapse navbar-collapse  w-auto  max-height-vh-100"
          id="sidenav-collapse-main"
        ></div>

        <div
          class="collapse navbar-collapse  w-auto  max-height-vh-100"
          id="sidenav-collapse-main"
        >
          <ul class="navbar-nav navbar_nav_1">
            <li class="dropdown">
            
              {Sidebar &&
                Sidebar?.map((data, index) => {
                  return (
                    <Fragment key={index}>
                      <ul className="navbar-nav">
                        <li className="dropdown">
                          <a
                            className="btn dropdown-toggle d-flex"
                            href="#"
                          
                            data-bs-toggle="dropdown"
                            
                            data-bs-auto-close="outside"
                          >
                            <div className="text-white text-center me-2 d-flex align-items-center justify-content-center">
                              <i class={data?.menuIcon} aria-hidden="true"></i>
                            </div>

                            <span className="nav-link-text ms-1">
                              {data?.menu}
                            </span>
                          </a>

                          <ul
                            className="sub_menu dropdown-menu"
                            aria-labelledby="dropdownMenuLink"
                          >
                            {data?.submainMenu
?.map((item, index) => {
            

                              return (
                                <Fragment key={index}>
                                  <li className="d-flex">
                                    <i
                                      class={item?.subMenuIcon}
                                      aria-hidden="true"
                                    ></i>
                                  
                                    <Link
                                      to={`/dashboard/${item?.subMenu?.replaceAll(
                                        " ",
                                        ""
                                      )}`}
                                      className="ms-2"
                                    >
                                      {item.subMenu}
                                    </Link>
                                  </li>
                                </Fragment>
                              );
                            })}
                          </ul>
                        </li>
                      </ul>
                    </Fragment>
                  );
                })}
            
            </li>
          </ul>

         
        </div>
      </aside> */}

      <div class={navopen ? "sidebar px-0" : "sidebar px-0 close"}>
        <div class="logo-details d-flex justify-content-between align-items-start px-3">
          {navopen && (
            <Link to="/" className="w_31 " id="hidefoto">
              <img className="img-fluid d-block" src={AltLogo} />
            </Link>
          )}
          {/* <span class="logo_name">Fire Bird</span> */}
          {navopen == false ? (
            <MenuIcon
              id="iconNavbarSidenav1"
              className="toggl_icon ms-auto mx-auto cursor-pointer"
              onClick={() => setnavopen(!navopen)}
            />
          ) : (
            <MenuOpenIcon
              id="iconNavbarSidenav2"
              className="toggl_icon ms-auto cursor-pointer"
              onClick={() => setnavopen(!navopen)}
            />
          )}
        </div>

        {/* <li
          className="nav-item ps-3 d-flex align-items-center"
          onClick={() => setIsOpen(!isOpen)}
        >
          <a
            className="nav-link text-body p-0"
            id="iconNavbarSidenav"
            style={{ cursor: "pointer" }}
            onClick={() => setnavopen(!navopen)}
          >
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
            </div>
          </a>
        </li> */}

        <ul
          className={navopen ? "nav-links mt-4" : "nav-links nv_mx mt-4"}
          id="nv_mx"
        >
          <Search
            className={navopen ? "" : "d-none"}
            style={{
              // border: "2px solid rgb(170 176 179)",
              marginTop: "1rem",
              width: "88%",
              marginLeft: "1rem",
            }}
            onChange={(e) => {
              setsearch(e.target.value);
              if (e.target.value?.length == 0) {
                // console.log({ indexxx });
                setMenuClass(indexxx);
              } else {
                let arrrr = JSON.parse(JSON.stringify(MenuClass));

                for (let vall of Object.keys(arrrr)) {
                  arrrr[vall] = "my-1 showMenu";
                  // console.log({ element });
                }
                // console.log("arrr22r", arrrr);

                setMenuClass(arrrr);
                setMenuClass1(arrrr);
              }

              setMenuSearch(
                Menu?.filter((se) => {
                  let menuFound = se.menu
                    ?.toLowerCase()
                    .includes(e.target.value?.toLowerCase());
                  if (menuFound) {
                    return se;
                  } else {
                    // console.log("LLLLLLL", se?.subMenu);
                    let subMenuFound = se?.subMenu?.some((se1) => {
                      return se1?.subMenu
                        ?.toLowerCase()
                        .includes(e.target.value?.toLowerCase());
                    });
                    // console.log({ subMenuFound });

                    if (subMenuFound) {
                      return se;
                    }
                  }
                })
              );
            }}
          >
            <SearchIconWrapper>
              <SearchIcon
                style={{ color: "rgb(170 176 179)", fontSize: "20px" }}
              />
            </SearchIconWrapper>
            <StyledInputBase
              style={{ color: "rgb(170 176 179)" }}
              placeholder="Search…"
              inputProps={{ "aria-label": "search" }}
            />
          </Search>

          {/* <li
            className={navopen ? "my-4" : "my-4 showMenu"}
            id="li_sidebar_main"
          >
            <Link to="/">
              <Icon
                className={!navopen ? "mx-auto" : ""}
                component="i"
                sx={{ color: "white" }}
              >
                <CalendarTodayIcon className="me-2" />
              </Icon>
              {navopen ? (
                <span
                  id="span_sidebar_text"
                  class="link_name d-block ms-4 me-auto"
                  style={{ fontSize: "15px" }}
                >
                  Dashboard
                </span>
              ) : null}
            </Link>
          </li> */}
          {MenuSearch &&
            MenuSearch?.map((data, index) => {
              if (data?.isActive == true) {
                return (
                  <Link
                    to={data?.menu == "Dashboard" ? "/" : null}
                    // className=""
                    // aria-expanded="false"
                  >
                    <li
                      onClick={(e) => {
                        // document
                        //   .getElementById(`li_sidebar_main${index}`)
                        //   .classList.toggle("showMenu");

                        // if (data.menu == "Dashboard") {
                        //   history.replace("/");
                        // }
                        if (screensize < 667) {
                          if (data?.subMenu?.length == 0) {
                            setnavopen(false);
                          }
                        }

                        // console.log("YYYYYYYYY", e, e.target.id);
                        if (
                          e.target.id != `submenuLink${index}` &&
                          e.target.id != `submenuIcon${index}` &&
                          e.target.id != `submenuSpan${index}`
                        ) {
                          let arrrr = JSON.parse(JSON.stringify(MenuClass));

                          localStorage.setItem("sideindex", index);
                          setactiveIndex(index);

                          for (let vall of Object.keys(arrrr)) {
                            console.log(
                              vall,
                              arrrr,
                              "OOOOOOOOOO",
                              arrrr[`class${data.menu.replaceAll(" ", "")}`],
                              vall,
                              `class${data.menu.replaceAll(" ", "")}`,
                              vall == `class${data.menu.replaceAll(" ", "")}`
                            );

                            if (
                              vall == `class${data.menu.replaceAll(" ", "")}`
                            ) {
                              if (data.menu == "Dashboard") {
                                arrrr[`class${data.menu.replaceAll(" ", "")}`] =
                                  "my-2  activelinks activeLink";
                              } else {
                                if (
                                  arrrr[
                                    `class${data.menu.replaceAll(" ", "")}`
                                  ] == "my-2 showMenu activelinks activeLink"
                                ) {
                                  // console.log("In");
                                  arrrr[
                                    `class${data.menu.replaceAll(" ", "")}`
                                  ] = "my-2 activelinks activeLink";
                                } else {
                                  // console.log(
                                  //   "TTTTTTTTTTT",
                                  //   arrrr[`class${data.menu.replaceAll(" ", "")}`]
                                  // );
                                  arrrr[
                                    `class${data.menu.replaceAll(" ", "")}`
                                  ] = "my-2 showMenu activelinks activeLink";
                                  // console.log(
                                  //   "TTTTTTTTTTT",
                                  //   arrrr[`class${data.menu.replaceAll(" ", "")}`]
                                  // );
                                }
                              }
                            } else {
                              // console.log(
                              //   "YYYYYYY",
                              //   `class${data.menu.replaceAll(" ", "")}`,
                              //   vall
                              // );
                              arrrr[vall] = "my-2";
                            }
                          }

                          // console.log({ element });
                          // arrr.push(element);

                          // console.log("arrr22r", arrrr);
                          localStorage.setItem(
                            "menuclasses",
                            JSON.stringify(arrrr)
                          );
                          setindexxx(arrrr);

                          setMenuClass(arrrr);
                          setindexcolor(index);
                          localStorage.setItem("indexcolor", index);
                          // setMenuClass(
                          //   JSON.parse(localStorage.getItem("menuclasses"))
                          // );

                          // navopen &&
                          //   document
                          //     .getElementById(`li_sidebar_main${index}`)
                          //     .classList.toggle("showMenu");
                        }
                      }}
                      className={
                        navopen
                          ? MenuClass?.[`class${data.menu.replaceAll(" ", "")}`]
                          : MenuClass?.[`class${data.menu.replaceAll(" ", "")}`]
                      }
                      id={`li_sidebar_main${index}`}
                      key={index}
                      // className="my-1"

                      // key={index}
                    >
                      {/* </Link> */}

                      <div class="iocn-link d-block">
                        <a>
                          <Icon
                            // sx={{ marginLeft: "20px" }}
                            className={!navopen ? "mx-auto" : ""}
                            component="i"
                            sx={{ color: "white" }}
                          >
                            {data.menuIcon}
                          </Icon>
                          {navopen && (
                            <span
                              id="span_sidebar_text"
                              // class="link_name ms-4 me-auto"
                              class={
                                index == localStorage.getItem("indexcolor")
                                  ? "link_name ms-3 me-auto activeLink"
                                  : "link_name ms-3 me-auto "
                              }
                              // className="btn btn-secondary dropdown-toggle"
                              // href="#"
                              // role="button"
                              // data-bs-toggle="dropdown"
                              // aria-expanded="false"
                            >
                              {" "}
                              {data?.menu}
                            </span>
                          )}
                          {data?.subMenu?.length == 0 ? null : (
                            <Icon
                              className="arrow toggle_icon_sidebar"
                              component="i"
                              // onClick={()=>{

                              // }}
                              sx={{ color: "white" }}
                            >
                              keyboard_arrow_down_icon
                            </Icon>
                          )}
                        </a>

                        {/* <Icon
                        className="arrow toggle_icon_sidebar"
                        component="i"
                        sx={{ color: "white" }}
                      >
                        keyboard_arrow_down_icon
                      </Icon> */}
                        {/* 
                      <i class="bx bxs-chevron-down arrow"></i> */}
                      </div>
                      <ul class="sub-menu px-2 py-1">
                        <li>
                          <a class="link_name">{data?.menu}</a>
                        </li>
                        {data?.subMenu?.length != 0 ? (
                          <>
                            {data?.subMenu?.map((item, indexx) => {
                              return (
                                <Fragment key={index}>
                                  <li
                                    id={navopen ? "" : "subMenuChanges"}
                                    onClick={(e) => {
                                      if (item.subMenu == "Mark Attendance") {
                                        setTimeout(() => {
                                          document
                                            .getElementById("modalbuuton")
                                            .click();
                                        }, 500);
                                      }
                                      if (screensize < 667) {
                                        setnavopen(false);
                                      }

                                      if (search?.length > 0) {
                                        let arrrr = JSON.parse(
                                          JSON.stringify(MenuClass)
                                        );

                                        // if (screensize < 667) {
                                        //   setnavopen(!navopen);
                                        // }

                                        for (let vall of Object.keys(arrrr)) {
                                          if (
                                            vall ==
                                            `class${data.menu.replaceAll(
                                              " ",
                                              ""
                                            )}`
                                          ) {
                                            if (
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] ==
                                              "my-2 showMenu activelinks activeLink"
                                            ) {
                                              // console.log("In");
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] = "my-2 activelinks activeLink";
                                            } else {
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] =
                                                "my-2 showMenu activelinks activeLink";
                                            }
                                          } else {
                                            arrrr[vall] = "my-2";
                                          }
                                        }
                                        localStorage.setItem(
                                          "menuclasses",
                                          JSON.stringify(arrrr)
                                        );
                                        setindexxx(arrrr);
                                      }
                                      if (navopen == false) {
                                        let arrrr = JSON.parse(
                                          JSON.stringify(MenuClass)
                                        );

                                        localStorage.setItem(
                                          "sideindex",
                                          index
                                        );
                                        setactiveIndex(index);

                                        for (let vall of Object.keys(arrrr)) {
                                          // console.log(
                                          //   "OOOOOOOOOO",
                                          //   arrrr[
                                          //     `class${data.menu.replaceAll(" ", "")}`
                                          //   ],
                                          //   vall,
                                          //   `class${data.menu.replaceAll(" ", "")}`,
                                          //   vall ==
                                          //     `class${data.menu.replaceAll(" ", "")}`
                                          // );

                                          if (
                                            vall ==
                                            `class${data.menu.replaceAll(
                                              " ",
                                              ""
                                            )}`
                                          ) {
                                            if (
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] ==
                                              "my-2 showMenu activelinks activeLink"
                                            ) {
                                              // console.log("In");
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] = "my-2 activelinks activeLink";
                                            } else {
                                              // console.log(
                                              //   "TTTTTTTTTTT",
                                              //   arrrr[
                                              //     `class${data.menu.replaceAll(
                                              //       " ",
                                              //       ""
                                              //     )}`
                                              //   ]
                                              // );
                                              arrrr[
                                                `class${data.menu.replaceAll(
                                                  " ",
                                                  ""
                                                )}`
                                              ] =
                                                "my-2 showMenu activelinks activeLink";
                                              // console.log(
                                              //   "TTTTTTTTTTT",
                                              //   arrrr[
                                              //     `class${data.menu.replaceAll(
                                              //       " ",
                                              //       ""
                                              //     )}`
                                              //   ]
                                              // );
                                            }
                                          } else {
                                            // console.log(
                                            //   "YYYYYYY",
                                            //   `class${data.menu.replaceAll(" ", "")}`,
                                            //   vall
                                            // );
                                            arrrr[vall] = "my-2";
                                          }
                                        }

                                        // console.log({ element });
                                        // arrr.push(element);

                                        // console.log("arrr22r", arrrr);
                                        localStorage.setItem(
                                          "menuclasses",
                                          JSON.stringify(arrrr)
                                        );
                                        setindexxx(arrrr);

                                        setMenuClass(arrrr);
                                        setindexcolor(index);

                                        localStorage.setItem(
                                          "indexcolor",
                                          data.menu.replaceAll(" ", "")
                                        );

                                        // setMenuClass(
                                        //   JSON.parse(localStorage.getItem("menuclasses"))
                                        // );

                                        // navopen &&
                                        //   document
                                        //     .getElementById(`li_sidebar_main${index}`)
                                        //     .classList.toggle("showMenu");
                                      }
                                    }}
                                    // onClick={(e) => {
                                    //   // console.log("subbb", item);

                                    //   // ------------------------------------------------------------------------------------

                                    //   // --------------------------------------------------

                                    //   let arrrr = [...sidebarr];

                                    //   let arrr = [];
                                    //   for (
                                    //     let indexxx = 0;
                                    //     indexxx < arrrr.length;
                                    //     indexxx++
                                    //   ) {
                                    //     let element = arrrr[indexxx];
                                    //     // console.log("arrrr", element, data);
                                    //     if (navopen) {
                                    //       // console.log(
                                    //       //   element[`class${indexxx}`],
                                    //       //   data?.menu
                                    //       // );
                                    //       if (index == indexxx) {
                                    //         // if (
                                    //         //   element[`class${indexxx}`] ==
                                    //         //     "my-4 showMenu activelinks" ||
                                    //         //   element[`class${indexxx}`] ==
                                    //         //     "my-4 showMenu"
                                    //         // ) {
                                    //         //   console.log("In");
                                    //         //   element[`class${indexxx}`] =
                                    //         //     "my-4  activelinks";
                                    //         // } else {
                                    //         //   console.log("In else");
                                    //         //   element[`class${indexxx}`] =
                                    //         //     "my-4 showMenu activelinks";
                                    //         // }
                                    //         element[`class${indexxx}`] =
                                    //           "my-2 showMenu activelinks activeLink";

                                    //         // element[`class${indexxx}`] =
                                    //         //   "my-4 showMenu activelinks li_sidebar_mainComon";
                                    //         localStorage.setItem(
                                    //           "sideindex",
                                    //           index
                                    //         );
                                    //         setactiveIndex(index);
                                    //       } else {
                                    //         // console.log("else");
                                    //         // setactiveIndex(null);
                                    //         element[`class${indexxx}`] = "my-2";
                                    //       }
                                    //     } else {
                                    //       if (index == indexxx) {
                                    //         element[`class${indexxx}`] =
                                    //           "my-2 showMenu activelinks activeLink li_sidebar_mainComon";
                                    //         localStorage.setItem(
                                    //           "sideindex",
                                    //           index
                                    //         );
                                    //         setactiveIndex(index);
                                    //       } else {
                                    //         // setactiveIndex(null);
                                    //         element[`class${indexxx}`] =
                                    //           "my-2 showMenu  li_sidebar_mainComon";
                                    //       }
                                    //     }
                                    //     // console.log({ element });
                                    //     arrr.push(element);
                                    //   }
                                    //   // console.log({ arrr });

                                    //   setMenuClass1(arrr);
                                    //   // dispatch(setmenuDetails(data));
                                    //   // dispatch(setsubMenu(item));
                                    //   // navopen &&
                                    //   //   document
                                    //   //     .getElementById(`li_sidebar_main${index}`)
                                    //   //     .classList.toggle("showMenu");

                                    //   // navopen &&
                                    //   //   document
                                    //   //     .getElementById(`li_sidebar_main${index}`)
                                    //   //     .classList.toggle("showMenu");

                                    //   localStorage.setItem(
                                    //     "setmenuDetails",
                                    //     JSON.stringify(data)
                                    //   );
                                    //   localStorage.setItem(
                                    //     "setsubMenu",
                                    //     JSON.stringify(item)
                                    //   );
                                    // }}
                                    // key={index}
                                    // // className={
                                    // //   location.pathname ==
                                    // //   `/dashboard/${item?.subMenu?.replaceAll(
                                    // //     " ",
                                    // //     ""
                                    // //   )}`
                                    // //     ? "activelinks"
                                    // //     : ""
                                    // // }
                                    // id={navopen ? "" : "subMenuChanges"}
                                    className={
                                      `/dashboard/${item?.subMenu?.replaceAll(
                                        " ",
                                        ""
                                      )}` == location.pathname
                                        ? " showMenu subactive"
                                        : " showMenu "
                                    }
                                  >
                                    <Link
                                      id={`submenuLink${index}`}
                                      to={`/dashboard/${item?.subMenu?.replaceAll(
                                        " ",
                                        ""
                                      )}`}
                                      // className="btn btn-secondary dropdown-toggle"
                                      // href="#"
                                      // role="button"
                                      // data-bs-toggle="dropdown"
                                      // aria-expanded="false"
                                    >
                                      <Icon
                                        // className="arrow toggle_icon_sidebar  "
                                        component="i"
                                        sx={{
                                          color: "white",
                                          direction: "revert",
                                        }}
                                        id={`submenuIcon${index}`}
                                      >
                                        {item?.subMenuIcon}
                                      </Icon>
                                      <span
                                        className="ms-2 me-auto"
                                        id={`submenuSpan${index}`}
                                      >
                                        {item?.subMenu}
                                      </span>
                                    </Link>
                                    {/* <ul class="dropdown-menu n_mnu">
                                  <li>
                                    <a class="dropdown-item" href="#">
                                      Action
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="#">
                                      Another action
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="#">
                                      Something else here
                                    </a>
                                  </li>
                                </ul> */}
                                  </li>
                                </Fragment>
                              );
                            })}
                          </>
                        ) : null}
                      </ul>
                    </li>
                  </Link>
                );
              } //   }
            })}

          {/* <li>
            <div class="iocn-link">
              <a href="#">
                <i class="bx bx-book-alt"></i> 
                <span class="link_name">Posts</span>
              </a>
              <i class="bx bxs-chevron-down arrow"></i>
            </div>
            <ul class="sub-menu">
              <li>
                <a class="link_name" href="#">
                  Posts
                </a>
              </li>
              <li>
                <a href="#">Web Design</a>
              </li>
              <li>
                <a href="#">Login Form</a>
              </li>
              <li>
                <a href="#">Card Design</a>
              </li>
            </ul>
          </li> */}

          {/* <li>
            <a href="#">
              <i class="bx bx-cog"></i>
              <span class="link_name">Setting</span>
            </a>
            <ul class="sub-menu blank">
              <li>
                <a class="link_name" href="#">
                  Setting
                </a>
              </li>
            </ul>
          </li> */}
          {/* <li>
              <div class="profile-details">
                <div class="name-job">
                  <div class="profile_name">Prem Shahi</div>
                  <div class="job">Web Desginer</div>
                </div>
                <i class="bx bx-log-out"></i>
              </div>
            </li> */}
        </ul>
      </div>
    </>
  );
}
